module.exports = __webpack_public_path__ + "media/Alert.ceb38e7f.ogg";